import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as OilFieldActions from './oil-field.actions';
import { OilFieldService } from '../../services/oil-field.service';

@Injectable()
export class OilFieldEffects {
  loadOilField$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OilFieldActions.loadOilField),
      exhaustMap((_) =>
        this.oilFieldService.getOilField().pipe(
          map((data) =>
            OilFieldActions.loadOilFieldSuccess({ oilField: data })
          ),
          catchError((error) =>
            of(OilFieldActions.loadOilFieldFailure({ error }))
          )
        )
      )
    )
  );

  addOilField$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OilFieldActions.addOilField),
      concatMap(({ newOilField }) =>
        this.oilFieldService.createOilField(newOilField).pipe(
          map((data) => {
            this.notification.success('Saved Successfully');
            return OilFieldActions.addOilFieldSuccess({
              newOilField: data,
            });
          }),
          catchError((error) =>
            of(
              OilFieldActions.addOilFieldFailure({ error: error.error.message })
            )
          )
        )
      )
    )
  );

  updateOilField$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OilFieldActions.updateOilField),
      map((action) => action.updateOilField),
      concatMap((updateOilField) =>
        this.oilFieldService.updateOilField(updateOilField).pipe(
          map((_) => {
            this.notification.success('Updated Successfully');
            return OilFieldActions.updateOilFieldSuccess({
              updateOilField: updateOilField,
            });
          }),
          catchError((error) =>
            of(OilFieldActions.updateOilFieldFailure({ error: error.message }))
          )
        )
      )
    )
  );

  removeOilField$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OilFieldActions.removeOilField),
      map((action) => action.ids),
      concatMap((ids) =>
        this.oilFieldService.deleteOilField(ids).pipe(
          map(() => {
            this.notification.success('Deleted Successfully');
            return OilFieldActions.removeOilFieldSuccess({ ids });
          }),
          catchError((error) =>
            of(OilFieldActions.updateOilFieldFailure({ error: error.message }))
          )
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private oilFieldService: OilFieldService,
    private notification: NotificationService
  ) {}
}
